import React from "react";
import { Link } from "react-router-dom";
import { leftPanelActions } from "../../../context/actions/leftPanelActions";
import useStore from "../../../context/useStore";

const LeftPanel = () => {
  const [state, dispatch] = useStore();
  const actions = leftPanelActions(state, dispatch);
  const leftPanelProps = state.leftPanel;

  return (
    <>
      <div
        onClick={() => {
          actions.updateLeftPanel({ isOpen: false, content: null });
        }}
        className="position-fixed w-100 h-100 align-items-center justify-content-center"
        style={{
          display: leftPanelProps.isOpen ? "flex" : "none",
          top: 0,
          left: 0,
          background: "rgb(0 0 0 / 54%)",
          zIndex: "99999",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <div
          className={
            "bg-white position-fixed p-3 flex-column align-items-start shadow-lg " +
            (leftPanelProps.isOpen ? "animated fadeInLeft faster" : "")
          }
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "58%",
            height: "100%",
            maxWidth: "400",
            borderTopRightRadius: 30,
            borderBottomRightRadius: 30,
            overflowY: "scroll",
            left: 0,
            top: 0,
            zIndex: "99999",
            minWidth: 450,
          }}
        >
          {leftPanelProps.backUrl && (
            <Link className="btn btn-link" to={leftPanelProps.backUrl}>
              <i className="fa fa-arrow-left mr-2" />
              retour à la page d'origine
            </Link>
          )}
          {leftPanelProps.content}
          {/* 
          <div
            className="d-flex align-items-center justify-content-end w-100 "
            style={{ position: "fixed", bottom: 0, right: 0 }}
          >
            {leftPanelProps.actions}
            <button
              onClick={() =>
                actions.updateLeftPanel({ isOpen: false, content: null })
              }
              className="btn btn-default w-100"
            >
              Fermer
            </button>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default LeftPanel;
